module.exports = __webpack_public_path__ + "static/media/Doing the Right Thing.334725dd.jpg";